<template>
  <div class="sf-level-item sf-btn-bar sf-btn-bar--no-clip">
    <slot></slot>
    <a
      href="#"
      class="sf-btn sf-btn-bar-item tw-py-2 tw-leading-4"
      data-testid="carousel-prev"
      @click.prevent.stop="handlePrevClick"
    >
      <i class="fa fa-chevron-left" />
    </a>
    <a
      href="#"
      class="sf-btn sf-btn-bar-item tw-py-2 tw-leading-4"
      data-testid="carousel-next"
      @click.prevent.stop="handleNextClick"
    >
      <i class="fa fa-chevron-right" />
    </a>
  </div>
</template>

<script setup lang="ts">
interface Props {
  previousAction: string
  nextAction: string
}

const props = defineProps<Props>()

function handlePrevClick() {
  window.Turbolinks.visit(props.previousAction)
}

function handleNextClick() {
  window.Turbolinks.visit(props.nextAction)
}
</script>
